module.exports = __webpack_public_path__ + "media/images/photos/2-c41c794131b964a9deed42aa60555d59.jpg";